module.exports = __webpack_public_path__ + "img/icon-file-upload.bf07a698.svg";